import axios from 'axios';
import AuthService from './AuthService';
import {getConfig} from '../config';
import { HttpApiClient } from './HttpApiClient';

const getUserFromLocalStorage = () => JSON.parse(localStorage.getItem(getConfig("userLocalStorage")))
const jwtExpired = jwt => new Date() > new Date(jwt.exp*1000)
const userIsValid = user => (
  ['AccessToken', 'IdToken', 'RefreshToken', 'JwtToken'].find(
    k => !Object.keys(user).includes(k)
  ) == null
)

class ApiCore {

  constructor() {
    const baseUrl = getConfig("apiEndpoint");

    this.instance = new HttpApiClient({
      baseUrl,
      onBeforeRequest: async () => {
        const user = getUserFromLocalStorage();
        const goToAuth = () => window.location.replace('/auth')

        if (user && !userIsValid(user)) goToAuth()
        if (user && userIsValid(user) && jwtExpired(user.JwtToken)){

          if (!user.RefreshToken) goToAuth()

          await AuthService.refresh(user.RefreshToken)
            
            // safety net: if something goes wrong on storing user we make sure to redirect to auth
            .then(() => !getUserFromLocalStorage() && goToAuth())
            .catch(goToAuth)
        }
      }
    })

    this._instance = axios.create({
      baseURL: baseUrl,
      headers: {
        'Content-Type': 'application/json',
        'dbg': 'cors-not-working'
      },
    });
    this._instance.interceptors.request.use(
      function(config) {
        let user = JSON.parse(localStorage.getItem(getConfig("userLocalStorage")));
        if(new Date() >= new Date((user["JwtToken"]["exp"]*1000))){
          if(user.RefreshToken){
            return AuthService.refresh(user.RefreshToken).then(response => {       
              user = JSON.parse(localStorage.getItem(getConfig("userLocalStorage")));     
              if (user) {
                config.headers["Content-Type"] = 'application/json';
                config.headers["Authorization"] = user.AccessToken;
                return config;
              }else{
                window.location.replace("/auth");
              }
            }).catch(error => {
              window.location.replace("/auth");
            });
          }else{
            window.location.replace("/auth");
          }
        }else{
          if (user) {
            config.headers["Content-Type"] = 'application/json';
            // config.headers["Authorization"] = user.AccessToken;
            config.headers["accessToken"] = user.AccessToken;
            config.headers["idToken"] = user.IdToken;
            config.headers["refreshToken"] = user.RefreshToken;
            return config;
          }else{
            window.location.replace("/auth");
          }
        }
        return null;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  }

}

export default ApiCore;
